import { Component } from 'preact'
import { SVG } from '.'

export default class Tabs extends Component {
  constructor(props) {
    super()

    let selectedIndex = -1
    if (props.selectedIndex != undefined) {
      selectedIndex = props.selectedIndex
    }

    this.state = { selectedIndex }
  }

  componentDidMount() {
    this.selectIndex(0)
  }

  componentWillReceiveProps(props) {
    let { selectedIndex } = props

    if (selectedIndex != undefined) {
      this.setState({ selectedIndex })
    }
  }

  selectIndex(i) {
    let { selectedIndex } = this.state
    let { onTabSelected } = this.props
    if (selectedIndex == i) return

    this.setState({ selectedIndex: i })
    if (onTabSelected) {
      onTabSelected(i)
    }
  }

  render() {
    let { getContentForIndex, tabs, actions } = this.props
    let { selectedIndex } = this.state

    const showTabs = !!tabs.length

    return (
      <div class="tabs-container">
        <div class="columns-middle">
          {showTabs && (
            <div class="tabs light-box columns">
              {tabs.map(({ label, title }, i) => {
                let selected = selectedIndex == i

                return (
                  <div
                    onClick={() => {
                      this.selectIndex(i)
                    }}
                    class={Missive.classNames({
                      'tab': true,
                      'tab--selected': selected,
                    })}
                    title={title}
                  >
                    <span>{label}</span>
                  </div>
                )
              })}
            </div>
          )}
          {actions && (
            <div className="tabs-action">
              {actions?.map(({ iconName, callback, title }) => (
                <button class="button" onClick={() => callback(selectedIndex)} title={title}>
                  <SVG name={iconName} size={16} />
                </button>
              ))}
            </div>
          )}
        </div>
        <div class="tabs-content light-box padding">
          {getContentForIndex && selectedIndex > -1 ? getContentForIndex(selectedIndex) : null}
        </div>
      </div>
    )
  }
}
